import request from '@/utils/request'
let baseURL = '/mall-shop';

// 店铺首页(该接口缺少shopInfo字段，可直接使用 introduce 接口)
export function shopHome(data) {
  return request({
    url: '/api/app/v1/shop/home',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
shopId (integer): 店铺ID
}
*/


// 店铺 查看店铺介绍 (详情)
export function introduce(data) {
  return request({
    url: '/api/app/v1/shop/introduce',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
shopId (integer): 店铺ID
}
*/



// 店铺 关注、取消关注
export function focusShop(data) {
  return request({
    url: '/api/app/v1/shop/focusShop',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
shopId (integer): 店铺ID
}
*/

// 店铺搜索引擎接口
export function mallShop(data) {
  return request({
    url: '/api/search/v1',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
address (string, optional): 地址 ,
areaId (integer, optional): 区域ID ,
auditStatus (string, optional): 审核状态：DRAFT-草稿；INIT_AUDIT-提交初审；INIT_AUDIT_OK-初审通过；INIT_AUDIT_NG-初审不通过；UPDATE_AUDIT-提交更新审核；UPDATE_AUDIT_OK-更新审核通过；UPDATE_AUDIT_NG-更新审核不通过（商品只能有一个在审版本，提交新的版本时应撤销上一次提审） = ['DRAFT', 'INIT_AUDIT', 'INIT_AUDIT_OK', 'INIT_AUDIT_NG', 'UPDATE_AUDIT', 'UPDATE_AUDIT_OK', 'UPDATE_AUDIT_NG'],
gmtCreateEnd (string, optional): 创建时间-结束时间 ,
gmtCreateStart (string, optional): 创建时间-开始时间 ,
lat (number, optional): 纬度 ,
levelName (string, optional): 等级名称 ,
lon (number, optional): 经度 ,
openStatus (string, optional): 开业状态：OPEN-营业；CLOSED-停业；FORCE_CLOSED-强制停业；EXPIRED_CLOSED-到期停业 = ['OPEN', 'CLOSED', 'FORCE_CLOSED', 'EXPIRED_CLOSED'],
page (integer, optional),
parentId (integer, optional): 父级ID ,
query (string, optional): 检索词 ,
radius (number, optional): 以给定经纬度为中心的半径范围（单位：米） ,
selfPickUpEnabled (boolean, optional): 实体店是否支持到店自提 ,
shopBelongingType (string, optional): 店铺归属类型：INDEPENDENT-独立经营；CHAIN-连锁经营 = ['INDEPENDENT', 'CHAIN'],
shopFormType (string, optional): 店铺载体类型：PURE_ONLINE-网店；HAS_REAL-有实体店 = ['PURE_ONLINE', 'HAS_REAL'],
shopId (integer, optional): 店铺ID ,
shopName (string, optional): 店铺名称 ,
shopSubjectType (string, optional): 店铺主体类型：PERSONAL-个人店铺；TEAM-团队店铺；COMPANY-企业店铺 = ['PERSONAL', 'TEAM', 'COMPANY'],
size (integer, optional),
userId (string, optional): 开店用户ID ,
verifyStatus (string, optional): 认证状态：NONE-未认证；AUDIT-审核中;PERSONAL-个人认证；TEAM-团队认证；COMPANY-企业认 = ['NONE', 'PERSONAL', 'TEAM', 'COMPANY']
}
* */


// 查询我关注的店铺列表
export function iFocus(data) {
  return request({
    url: '/api/app/v1/shop/iFocus',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
page (integer, optional),
shopName (string, optional): 店铺名称 ,
shopSysTypes (Array[string], optional): 店铺系统类型:SHOP_SYS_TYPE_KNOWLEDGE-知识类；SHOP_SYS_TYPE_GOODS-商品类；SHOP_SYS_TYPE_BOOK-图书类(默认查知识类) ,
size (integer, optional)
}
* */


// 获取用户店铺列表
export function myShops() {
  return request({
    url: '/api/app/v1/shop/myShops',
    method: 'post',
    baseURL
  })
}


// 根据店铺ID集合查询店铺基础信息列表
export function listShops(data) {
  return request({
    url: '/api/app/v1/shop/listShops',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
shopIds (Array[integer]): 店铺ID集合
}
* */


// 记录用户浏览店铺
export function shopViewed(data) {
  return request({
    url: '/api/app/v1/shop/viewed',
    method: 'post',
    baseURL,
    data
  })
}